import { createContext } from 'react';
export var BasenameContext = createContext('');
//# sourceMappingURL=BasenameContext.js.map